'use strict';
module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-pure.js
// module id = ZPTL
// module chunks = 15